var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st1{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st2{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st3{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st4{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st5{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st6{fill:white;}\r\n    .st7{fill:white;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n    .st8{fill:none;stroke:#37474F;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resume",
    transform: "scale(1.2, 1.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,2.5L11,2.5c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h0c-1.1,0-2-0.9-2-2v-3c0-0.6,0.4-1,1-1       h0c0.6,0,1,0.4,1,1v3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,50.5V54c0,1.4-1.1,2.5-2.5,2.5H42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,61H12.5c-1.4,0-2.5-1.1-2.5-2.5l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,46v12.5c0,1.4-1.1,2.5-2.5,2.5H37.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,9L50,9c1.4,0,2.5,1.1,2.5,2.5v20.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,56.5H8.5C7.1,56.5,6,55.4,6,54V7c0-1.4,1.1-2.5,2.5-2.5h37C46.9,4.5,48,5.6,48,7v26.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,23.5H32c-0.6,0-1-0.4-1-1v-12c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1v12C43,23,42.6,23.5,42,23.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 37,
    cy: 16.5,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41,23.5h-8v-0.3c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4V23.5z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 23.5,
    x2: 19,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 15.5,
    x2: 19,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 18.5,
    x2: 27,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 28.5,
    x2: 43,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 33.5,
    x2: 27,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 38.5,
    x2: 27,
    y2: 38.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 43.5,
    x2: 27,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 48.5,
    x2: 19,
    y2: 48.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 35,
    y1: 0.5,
    x2: 40,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 42,
    y1: 0.5,
    x2: 43,
    y2: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 56.5,
    y1: 19.5,
    x2: 56.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 56.5,
    y1: 26.5,
    x2: 56.5,
    y2: 27.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,34.2l0.7,0.7c1,1,1,2.6,0,3.5L37.8,57.8l-4.2-4.2L53,34.2C54,33.2,55.6,33.2,56.6,34.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.6,53.6 37.8,57.8 34.3,61.4 27.9,63.5 30,57.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.3,59.3 27.9,63.5 32.2,62.1 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.8,
    y1: 34.5,
    x2: 42.8,
    y2: 41.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 57.3,
    y1: 38.4,
    x2: 53,
    y2: 34.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon5);
export default __webpack_public_path__ + "static/media/nav-icon5.e68352e7b2a11f95b3b89eee291c14c1.svg";
export { ForwardRef as ReactComponent };